<li *ngFor="let lang of languages" role="menuitem">
  <div class="dropdown-item d-flex align-items-center cursor-pointer" (click)="handleLangChange(lang.value)">
    <i class="mdi mdi-web mdi-24px mr-2" [ngClass]="{ invisible: lang.value !== currentLanguage }"></i>
    {{ lang.title }}
  </div>
</li>
